import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, ref, computed } from "vue";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import ModalModule from "@/store/modules/modal";
import { useI18n } from "vue-i18n";
import DeviceModule from "@/store/modules/device";
import dayjs from "dayjs";
import POSConfigModule from "@/store/modules/pos-config";
import UserModule from "@/store/modules/user";
import CashFloatModule from "@/store/modules/cash-float";
import randomstring from "randomstring";
import { signCashTransferTransaction } from "@/utils/helpers/fiskaly";
import { handleCashTransferSync } from "@/utils/vue-helpers/cash-float";
import NotificationService from "@/services/notification.service";
import { MoneyInOutType } from "@smeetz/compliance-common";
import { PaymentMethod } from "@smeetz/order-common";
import { mapCashLocation, processMoneyInOutEvent } from "@/utils/helpers/compliance";
import { LogService } from "@/services/logging";
export default defineComponent({
  name: ModalComponents.CashInOut,
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var dialogFormVisible = ref(true);
    var modalVisible = dialogVisibleForStatus(ModalStatus.CashInOut);
    var isLoading = ref(false);
    var isCashIn = ref(true);
    var isCashOut = ref(false);
    var amount = ref(0.0);
    var locationId = ref(""); // const currencies = [
    //   { id: "CHF", label: "CHF" },
    //   { id: "EUR", label: "EUR" },
    // ];

    var groupCurrencies = computed(function () {
      // enable group currency only for cash in/out for now
      var groupCurrency = POSConfigModule.groupCurrencies.find(function (currency) {
        return currency.isDefault === 1;
      });

      if (groupCurrency) {
        return [groupCurrency];
      }

      return [POSConfigModule.groupCurrencies[0]];
    });
    var groupCurrency = computed(function () {
      var currency = groupCurrencies.value.find(function (c) {
        return c.isDefault === 1;
      }) || groupCurrencies.value[0];
      return currency;
    });
    var currency = ref(groupCurrency.value.label);
    var locationsList = computed(function () {
      return DeviceModule.locations.filter(function (l) {
        return l.id !== Number(hardwareLocationId.value);
      });
    });
    var hardwareLocationId = computed(function () {
      return DeviceModule.hardwareLocation ? DeviceModule.hardwareLocation.locationId : null;
    });
    var canConfirm = computed(function () {
      // user can confirm if
      // he entered amount greater than 0
      // he has at least one of "from" OR "to"
      var from = isCashOut.value ? hardwareLocationId.value : locationId.value;
      var to = isCashIn.value ? hardwareLocationId.value : locationId.value;
      return amount.value && from && to;
    });

    function cashInType() {
      isCashIn.value = true;
      isCashOut.value = false;
    }

    function cashOutType() {
      isCashIn.value = false;
      isCashOut.value = true;
    }

    function handleInputFocus(event) {
      if (event.target.value === "0") {
        event.target.value = "";
      }
    }

    function handleInputBlur(event) {
      if (event.target.value === "") {
        event.target.value = "0";
      }
    }

    return {
      t: t,
      modalVisible: modalVisible,
      dialogFormVisible: dialogFormVisible,
      cashInType: cashInType,
      cashOutType: cashOutType,
      isCashIn: isCashIn,
      isCashOut: isCashOut,
      amount: amount,
      currency: currency,
      groupCurrencies: groupCurrencies,
      locationsList: locationsList,
      locationId: locationId,
      isLoading: isLoading,
      canConfirm: canConfirm,
      hardwareLocationId: hardwareLocationId,
      handleInputFocus: handleInputFocus,
      handleInputBlur: handleInputBlur
    };
  },
  methods: {
    handleBeforeClose: function handleBeforeClose(done) {
      console.log("hi from handleBeforeClose"); // Lets make sure we destroy the dialog, because El-Dialog had a bug: when you click Esc or click outside the dialog, it does not destroy the dialog, which causes the dialog to fail rendering next time it is opened.

      ModalModule.setStatus(ModalStatus.Hidden);
      done(); // must be called to actually close the dialog
    },
    closeModal: function closeModal() {
      ModalModule.setStatus(ModalStatus.Hidden);
    },
    submit: function submit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var groupId, cashTransferIn, isSynced, eventData, transferAmount, amountInCents;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                groupId = POSConfigModule.groupId || UserModule.getUserGroupId; // Add a new CashTransfer of type (IN)

                cashTransferIn = {
                  _id: dayjs().toISOString(),
                  createdAt: dayjs().toISOString(),
                  amount: Number(_this.amount),
                  currency: _this.currency,
                  groupId: Number(groupId),
                  from: _this.isCashOut ? _this.hardwareLocationId : _this.locationId,
                  to: _this.isCashIn ? _this.hardwareLocationId : _this.locationId,
                  note: "",
                  channel: "Smeetz POS",
                  uuid: randomstring.generate(10)
                };
                _context.next = 5;
                return handleCashTransferSync(cashTransferIn);

              case 5:
                isSynced = _context.sent;

                if (isSynced) {
                  _context.next = 9;
                  break;
                }

                _this.isLoading = false;
                return _context.abrupt("return");

              case 9:
                _context.prev = 9;
                eventData = {
                  moneyInOutType: _this.isCashOut ? MoneyInOutType.PAY_OUT : MoneyInOutType.PAY_IN,
                  amount: _this.isCashOut ? -Number(_this.amount) : Number(_this.amount),
                  description: "Cash transfer ".concat(_this.isCashOut ? "OUT" : "IN"),
                  posDateTime: dayjs().toISOString(),
                  paymentType: PaymentMethod.CASH,
                  location: mapCashLocation(Number(_this.locationId))
                };
                _context.next = 13;
                return processMoneyInOutEvent(eventData);

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](9);
                LogService.info("Failed process money in/out event", {
                  error: _context.t0
                });

              case 18:
                // display a success message
                NotificationService.showCustomSuccess(_this.t("cashtransfer.cash-in-out-success")); // lets update transferAmount in the state

                transferAmount = _this.isCashOut ? -1 * Number(_this.amount) : Number(_this.amount);
                CashFloatModule.updateTransfersAmount(transferAmount * 100); // lets update sum of cash in and cash out

                if (_this.isCashIn) {
                  CashFloatModule.updateSumOfCashIn(Number(_this.amount) * 100);
                }

                if (_this.isCashOut) {
                  CashFloatModule.updateSumOfCashOut(Number(_this.amount) * 100);
                }

                amountInCents = _this.isCashOut ? -1 * _this.amount : _this.amount;
                _context.next = 26;
                return signCashTransferTransaction(cashTransferIn.uuid, amountInCents);

              case 26:
                _this.isLoading = false;

                _this.closeModal(); // if we're in Sales Closure page, refresh the cash float details


                if (!CashFloatModule.isClosingCashfloat) {
                  _context.next = 33;
                  break;
                }

                CashFloatModule.setIsClosingCashfloat(false);
                _context.next = 32;
                return _this.$nextTick();

              case 32:
                CashFloatModule.setIsClosingCashfloat(true);

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[9, 15]]);
      }))();
    }
  }
});